module.exports = __webpack_public_path__ + "img/10.27873ef5.jpg";